import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { featureBackgroundColor } from '../../styles/colors'

const ListWrapper = styled.div`
    width: 100%;
`

export const FeatureList = ({ children }: { children: ReactNode }) => <ListWrapper>{children}</ListWrapper>

export const FeaturesRow = styled.div`
    display: flex;
    margin-bottom: 20px;

    div + div {
        margin-left: 20px;
    }
`

const FeatureWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 50%;
    background-color: ${featureBackgroundColor};
    padding: 20px;

    > img {
        width: 50px;
        height: 50px;
    }

    > img,
    h6 {
        margin-bottom: 10px;
    }

    > p {
        margin: 0;
    }
`

type FeatureProps = {
    icon: string
    title: string
    children: ReactNode
}

export const Feature = ({ icon, title, children }: FeatureProps) => (
    <FeatureWrapper>
        <img src={icon} />
        <h6>{title}</h6>
        {children}
    </FeatureWrapper>
)
